export default __webpack_public_path__ + "d78b83f1.png";